var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.08 399.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#26286d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.78,396.78s-25.3-333.9,211.7-325.9S482.37,0,482.37,0s126.17,241.25-235.1,231.33A159,159,0,0,1,228,229.68C198.81,225.34,77.17,219.06.78,396.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.1,181.88S601,257.29,562.25,399.59H525.32s5.62-115.07-100.61-194.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.78,396.78l28.24.38s21.62-96.7,73-135l-65.58-5.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset 9.d4419e08.svg";
export { ForwardRef as ReactComponent };